import styled from 'styled-components';

interface Props {
  color?: string;
}

export const Checkbox = styled.input<Props>`
  -webkit-appearance: none;
  appearance: none;
  background-color: white;
  margin: auto;
  font: inherit;
  aspect-ratio: 1/1;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
  cursor: pointer;
  &::before {
    content: '';
    width: 0.7em;
    height: 0.7em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em ${({ theme, color }) => (color ? color : theme.colors.purple)};
  }
  &:checked::before {
    transform: scale(1.1);
  }
  &:checked {
    border: 0.15em solid ${({ theme, color }) => (color ? color : theme.colors.purple)};
  }
`;
